// Section articles similaires

import { Article, getRelatedArticles } from "@/data/articles";
import BlogCard from "./BlogCard";

interface RelatedArticlesProps {
  currentSlug: string;
  currentCategory: Article['category'];
}

const RelatedArticles = ({ currentSlug, currentCategory }: RelatedArticlesProps) => {
  const relatedArticles = getRelatedArticles(currentSlug, currentCategory, 3);

  // Ne pas afficher si pas d'articles similaires
  if (relatedArticles.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-[#0A0A0F] border-t border-white/[0.05]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-white text-center mb-10">
          A lire aussi
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {relatedArticles.map((article) => (
            <BlogCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedArticles;
